import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import SEOHead from '@/components/feature/SEOHead';
import HeroBanner from './components/HeroBanner';
import CategoryGrid from './components/CategoryGrid';
import FeaturedContent from './components/FeaturedContent';
import TrendingList from './components/TrendingList';
import FAQSection from './components/FAQSection';
import { platformStats } from '@/mocks/data';

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <SEOHead
        title="首页"
        description="欧美一区汇聚海量优质欧美影视、音乐与文化内容，为您提供最全面的欧美一区资源导航与推荐服务，畅享欧美一区带来的高清视听体验与多元文化魅力。"
        keywords="欧美一区,欧美一区高清资源,欧美一区影视导航,欧美一区在线观看,欧美一区内容推荐,欧美影视资源,欧美文化内容平台"
        canonicalPath="/"
        ogType="website"
        breadcrumbs={[{ label: '首页', href: '/' }]}
        jsonLd={{
          '@context': 'https://schema.org',
          '@type': 'WebPage',
          name: '欧美一区精选内容导航平台 - 首页',
          description: '欧美一区汇聚海量优质欧美影视、音乐与文化内容。',
          url: 'https://www.oumei1.com/',
          isPartOf: {
            '@type': 'WebSite',
            name: '欧美一区精选内容导航平台',
            url: 'https://www.oumei1.com/',
          },
        }}
      />

      <main>
        <Navbar />
        <HeroBanner />

        <section className="py-12 md:py-16 bg-background-50 border-b border-background-200/70">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
              {platformStats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-2xl md:text-3xl font-heading font-bold text-primary-600 mb-1">
                    {stat.value}
                  </div>
                  <div className="text-sm text-foreground-600">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <CategoryGrid />
        <FeaturedContent />
        <TrendingList />
        <FAQSection />

        <section className="py-12 md:py-16 bg-primary-500">
          <div className="max-w-7xl mx-auto px-4 md:px-6 text-center">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-background-50 mb-3">
              开始探索欧美一区的精彩世界
            </h2>
            <p className="text-sm md:text-base text-background-200 max-w-xl mx-auto mb-6">
              加入数百万用户，开启您的欧美一区高清视听之旅，发现更多优质欧美影视、音乐和文化内容。
            </p>
            <a
              href="/category/movies-tv"
              className="inline-block px-8 py-3 bg-background-50 text-primary-600 rounded-full text-sm font-medium hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer"
            >
              立即探索
            </a>
          </div>
        </section>

        <Footer />
      </main>
    </>
  );
}